import {Component, OnInit, Output, ViewChild} from '@angular/core';
import {OfertasService} from 'src/app/services/ofertas.service';
import {LogoutService} from 'src/app/services/logout.service';
import {Router} from '@angular/router';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {environment} from "../../../../environments/environment";
import ESCOcuppations from '../../../../assets/ESCOcuppations.json';

@Component({

    selector: 'app-tagging',
    templateUrl: './tagging.component.html',
    styleUrls: ['./tagging.component.css']
})




export class TaggingComponent implements OnInit {
    ofertas: any;

    voto = '';
    ready = false;
    placeholderTitle = 'Atención';
    placeholderDescription = 'Todavía no hay ofertas para mostrar';

    @ViewChild('description', {static: false}) private myEditable;
    oferta: { id: any; voto: string; };


    constructor(private ofertasService: OfertasService,
      private http: HttpClient,
                private router: Router, private logoutService: LogoutService) {
    }


    ngOnInit() {


        this.ofertasService.sendGetRequest().then(
            (data: any[]) => {
                console.log(data);
                this.ofertas = data[0];
                this.oferta = {
                    id: this.ofertas['id'],
                    voto: '',
                };
                this.ready = true;
                console.log(this.ofertas);
            }, () => {
                console.log('error');
            }
        ).then(r => {
            let texto = this.ofertas['description'];
            texto = texto.replace(/\\n/g, '\n');
          texto = texto.replace(/<br[^>]*>/g, "\n");
            this.myEditable.nativeElement.innerText = texto;
        });
        
    }


    isVisible(value) {
        // console.log(eval(value));
        return eval(value);
    }


    customFilter(object, keyToFind, valToFind){
      if(object.hasOwnProperty(keyToFind) && object[keyToFind] == valToFind)
          return object;
  
      for(var i=0; i<Object.keys(object).length; i++){
          if(typeof object[Object.keys(object)[i]] == "object"){
              var o = this.customFilter(object[Object.keys(object)[i]],keyToFind,valToFind);
              if(o != null)
                  return o;
          }
      }
  
      return null;
  }


  findNestedObj(entireObj, keyToFind, valToFind) {
  let foundObj;
  JSON.stringify(entireObj, (_, nestedValue) => {
    if (nestedValue && nestedValue[keyToFind] === valToFind) {
      foundObj = nestedValue;
    }
    return nestedValue;
  });
  return foundObj;
};

    ocupationName(code){
      
      
let ocName = this.customFilter(ESCOcuppations,'code',code)
console.log('hola amigo '+ocName)
      return ocName
    }

   
   
   
   
     getCIUO08CL(code) {
       return this.http.get(environment.apiUrl+'/ciuo08cl4d/'+code+'/').toPromise();
   
     }



    refresh(refreshing: boolean) {
        if (refreshing) {
            this.ngOnInit();
            this.goUp();


        }
    }

    logout() {
        this.logoutService.logout();
    }


  goUp() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 2);
  }

}
